import React from 'react';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import Button from '@common/buttons/Button';
import TopBanner from '@common/TopBanner';
import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import 'swiper/css';
import SwiperCore, { Autoplay, Navigation } from 'swiper';
import { useMediaQuery } from '@mui/material';
import Link from 'next/link';
SwiperCore.use([Navigation, Autoplay]);

const About = () => {
  const sm = useMediaQuery('(max-width:800px)');
  return (
    <>
      <TopBanner title="About Us" />
      <div className="grid grid-cols-1 lg:grid-cols-2 py-20 gap-5 container">
        <div>
          <Image
            width="2307"
            height="2344"
            src="/assets/images/about-top.png"
            alt="about"
            className="w-[80%]"
          />
        </div>
        <div>
          <div className="text-lg font-medium">
            Your Ideal Choice for Transportation in Shipley, Bradford, and Leeds
          </div>
          <div className="w-20 h-1 bg-primary my-2"></div>
          <div className="text-3xl font-medium mt-1">
            Serving our community for over 40 years
          </div>
          <div className="mt-5 text-black/50 space-y-4">
            Shipley Central Private Hire Taxis - the convenient choice for all
            your transportation needs. Whether you're going shopping, catching a
            train, or heading to the airport, we're ideally located between
            Shipley, Bradford, and Leeds. <br />
            <br />
            With fully licensed and vetted drivers, our fleet of new vehicles
            includes saloons, estate MPVs, and minibuses that can accommodate up
            to eight passengers and wheelchairs. Rest assured, all our vehicles
            are regularly inspected and well-maintained to ensure safety and
            compliance. <br />
            <br />
            No matter where you need to go, we serve a wide range of areas,
            including Shipley, Saltaire, Nabwood, Bingley, Cottingley, Baildon,
            Charlestown, Guiseley, Heaton, Otley, Leeds Bradford Airport, and
            Manchester Airport. <br />
            <br />
            For those requiring wheelchair-accessible vehicles, we have you
            covered. <br />
            <br />
            Whether it's a trip to the airport, bus station, or the coast, we
            provide reliable transportation. Book{' '}
            <Link href="/">
              <a className="text-primary font-bold">online</a>
            </Link>{' '}
            to enjoy the convenience of our fixed-price airport transfers and
            flight monitoring service. <br />
            <br />
            Additionally, we offer courier services for letters, packages, and
            small parcels throughout the area. Perfect for corporate clients and
            local hospitals, we can even provide a Same Day priority service if
            needed. <br />
            <br />
            Call us on{' '}
            <a className="text-primary font-bold" href="tel:01274595959">
              01274 595959
            </a>{' '}
            or book
            <Link href="/">
              <a className="text-primary font-bold"> online </a>
            </Link>{' '}
            online to arrange your courier service today. Choose Shipley Central
            Private Hire Taxis for reliable, safe, and convenient
            transportation.
          </div>
        </div>
      </div>
    </>
  );
};

export default About;

// Shipley Central: Your Ideal Choice for Transportation in Shipley, Bradford, and Leeds

// Experience safety and reliability with Shipley Central Private Hire Taxis. Our drivers are fully licensed and vetted for your peace of mind. With a fleet of new vehicles, including wheelchair-accessible options, we can accommodate all your transportation needs.

// We serve various areas, including Shipley, Saltaire, Nabwood, Bingley, Cottingley, Baildon, Charlestown, Guiseley, Heaton, Otley, Leeds Bradford Airport, and Manchester Airport. Whether you're going shopping, catching a train, or heading to the airport, we've got you covered.

// Our wheelchair-accessible vehicles are available for all occasions, from airport transfers to trips to the coast. Book online and rest assured that we're informed about which terminal your airline travels from. We'll collect you for a fixed price and monitor your flight for any delays.

// In addition to passenger transportation, we also offer courier services. We're happy to carry your letters, packages, and small parcels throughout the area. For our corporate clients and local hospitals, we even provide a Same Day priority service. Book your courier service with us today.
